import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form__control" };
const _hoisted_2 = ["disabled", "value", "required", "autocomplete", "id"];
const _hoisted_3 = ["disabled", "value", "required", "autocomplete", "id"];
import { computed } from "vue";
import { autocompleteAttr } from "./FormUtils";
import { choiceLabel } from "./fieldValues";
import { useFieldControl, useFieldModel } from "./useFieldControl";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlChoiceExpanded',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const { fieldOptions, emitChange, onFocus, onBlur } = useFieldControl(props, emit, 'FieldControlChoiceExpanded');
        const choices = computed(() => (fieldOptions.value.choices || [])
            .map(choice => ({ ...choice, label: choiceLabel(props.form, props.field, choice) })));
        const autocomplete = computed(() => autocompleteAttr(fieldOptions.value));
        // multiple: the selected values, in the order of the data, newly checked ones appended
        const model = useFieldModel(() => {
            if (!fieldOptions.value.multiple) {
                return props.data;
            }
            if (props.data && !Array.isArray(props.data)) {
                throw 'expected `data` to be an array';
            }
            return [...(props.data || [])];
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(choices.value, (choice) => {
                    return (_openBlock(), _createElementBlock("label", {
                        key: choice.value,
                        class: "form__radio-wrapper"
                    }, [
                        (_unref(fieldOptions).multiple)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                                onChange: _cache[1] || (_cache[1] = ($event) => (_unref(emitChange)(_unref(model)))),
                                onFocus: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                                onBlur: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                                disabled: _unref(fieldOptions).disabled || choice.disabled,
                                value: choice.value,
                                required: _unref(fieldOptions).required ?? undefined,
                                autocomplete: autocomplete.value,
                                id: __props.fieldId + '_' + choice.value
                            }, null, 40, _hoisted_2)), [
                                [_vModelCheckbox, _unref(model)]
                            ])
                            : _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 1,
                                type: "radio",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(model) ? (model).value = $event : null)),
                                onChange: _cache[5] || (_cache[5] = ($event) => (_unref(emitChange)(_unref(model)))),
                                onFocus: _cache[6] || (_cache[6] =
                                    //@ts-ignore
                                    (...args) => (_unref(onFocus) && _unref(onFocus)(...args))),
                                onBlur: _cache[7] || (_cache[7] =
                                    //@ts-ignore
                                    (...args) => (_unref(onBlur) && _unref(onBlur)(...args))),
                                disabled: _unref(fieldOptions).disabled || choice.disabled,
                                value: choice.value,
                                required: _unref(fieldOptions).required ?? undefined,
                                autocomplete: autocomplete.value,
                                id: __props.fieldId + '_' + choice.value
                            }, null, 40, _hoisted_3)), [
                                [_vModelRadio, _unref(model)]
                            ]),
                        _createTextVNode(" " + _toDisplayString(choice.label), 1)
                    ]));
                }), 128))
            ]));
        };
    }
});
